'use strict';

/**
 * Used to extend a resource instance with base methods.
 * They SHOULD extend base functionality on the data, but not change the
 * behavior (they should keep the same signature).
 *
 * For resources that require custom functionality but is not present in all
 * of them is better to define those methods in the individual resource
 * definition as Class or Instance methods
 *
 */
module.exports = {
};


// WEBPACK FOOTER //
// ./~/@skycatch/skydash-saturn/boosters/data/src/core/mixins/Base.js